import { useState } from "react";
import { components } from "react-select";
import { Theme } from "./constants";
import { BsCaretDownFill } from "react-icons/bs";
import { List } from 'react-virtualized';

export const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
        <BsCaretDownFill />
        </components.DropdownIndicator>
    );
};


export const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;
    if (Array.isArray(values)) {
      values = `${values.length} Selected`;
    }
    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

export const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    let textColor = "inherit";
    if (isDisabled) 
        { 
            bg = "rgb(230, 230, 230)";
            textColor= "rgb(77, 77, 77)";
        }
    if (isFocused && !isDisabled) bg = "rgb(245, 214, 228)";
    if (isActive) bg = Theme().colors.accent;

    const style = {
        alignItems: "center",
        backgroundColor: bg,
        color: textColor,
        display: "flex ",
        whiteSpace: "nowrap",
    };

    // prop assignment
    const props = {
        ...innerProps,
        onMouseDown,
        onMouseUp,
        onMouseLeave,
        style
    };
    return (
        <components.Option
          {...rest}
          isDisabled={isDisabled}
          isFocused={isFocused}
          isSelected={isSelected}
          getStyles={getStyles}
          innerProps={props}
        >
          <input className="me-2" type="checkbox" defaultChecked={isSelected} disabled={isDisabled} />
          {children}
        </components.Option>
    );
  };

export const SearchInputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    let textColor = "inherit";
    if (isDisabled) 
        { 
            bg = "rgb(230, 230, 230)";
            textColor= "rgb(77, 77, 77)";
        }
    if (isFocused && !isDisabled) bg = Theme().colors.accentLight;
    if (isActive) bg = Theme().colors.accent;

    const style = {
        alignItems: "center",
        backgroundColor: bg,
        color: textColor,
        display: "flex "
    };

    // prop assignment
    const props = {
        ...innerProps,
        onMouseDown,
        onMouseUp,
        onMouseLeave,
        style
    };
    return (
        <components.Option
          {...rest}
          isDisabled={isDisabled}
          isFocused={isFocused}
          isSelected={isSelected}
          getStyles={getStyles}
          innerProps={props}
        >
          {children}
        </components.Option>
    );
  };

export const MenuList = ({...props}) => {
  const rows = props.children || [];
  const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
    <div key={key} style={style} title={rows[index].props.data.label}>{rows[index]}</div>
  );

  return (
    <List
      style={{ width: '100%' }}
      width={300}
      height={rows?.length > 0  ? 300 : 46}
      rowHeight={36}
      rowCount={rows?.length || 0}
      rowRenderer={rowRenderer}
    />
  )
}